import React, { useEffect, useState } from 'react';
import AppHeader from '../Header';
import AppBody from '../Body';
import AppFooter from '../Footer';
import { BrowserRouter } from 'react-router-dom';
import debounce from 'lodash.debounce';
import axios from '../../Axios';
import { Urls } from '../../Urls';
import NoAccess from '../Shared/NoAccess';
import Loader from '../Loader';

import './AppLayout.css';

const AppLayout = () => {
  const [showLoader, setShowLoader] = useState(false);

  const invalidAccess = 'not verified';

  useEffect(() => {
   // getUser();
    setVh();
    window.addEventListener('resize', debounce(setVh, 200), false);

    return window.removeEventListener('resize', setVh, false);
  }, []);

  const setVh = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  // const getUser = () => {
  //   setShowLoader(true);

  //   axios
  //     .get(Urls.Users.GetCurrentUser)
  //     .then(res => {
  //       if (res.data && res.data.domain_status) {
  //         setShowLoader(false);

  //         res.data.domain_status === invalidAccess
  //           ? setHasAccess(States.Denied)
  //           : setHasAccess(States.Allowed);
  //       }
  //     })
  //     .catch(e => {
  //       setShowLoader(false);
  //       console.log(e);
  //     });
  // };

  return (
  <>
          <BrowserRouter>
            <AppHeader />
            <AppBody />
            <AppFooter />
          </BrowserRouter>
       
    </>
  );
};


export default AppLayout;
